import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { ReactComponent as PipedriveExportIcon } from 'Assets/svg/export_icons/pipedrive_export.svg';
import { CRMExportHeader } from './crmExportComponents';
import Input from '../newInputField';
import CancelSaveButton from '../CancelSaveButton';

class PipedriveExportState {
  @observable showPopup = false;

  defaultPopupValue = {
    callback() {
      console.log('callback');
    },
  };

  @observable popupValues = this.defaultPopupValue;

  @action
  setShowPopup = val => {
    this.showPopup = val;
    if (val === false) this.popupValues = this.defaultPopupValue;
  };

  @action
  setPopupValues = val => {
    this.popupValues = { ...this.popupValues, ...val };
    console.log(this.popupValues);
  };
}
const pipedriveExportState = new PipedriveExportState();

const PipedriveAuthenticationPopup = observer(props => {
  const defautState = { apikey: '', companyDomain: '' };
  const [stateValues, setStateValues] = React.useState(defautState);
  const [errors, setErrors] = React.useState(defautState);

  const confirmClick = () => {
    const regexMatch = /(?<companyDomain>[^/.]+)(?=\.pipedrive\.com)/.exec(
      stateValues.companyDomain,
    );
    const stateValueCopy = {
      apikey: stateValues.apikey,
      companyDomain: regexMatch?.groups?.companyDomain || '',
    };
    if (
      stateValueCopy.apikey !== undefined &&
      stateValueCopy.apikey !== '' &&
      stateValueCopy.companyDomain !== undefined &&
      stateValueCopy.companyDomain !== ''
    ) {
      pipedriveExportState.popupValues.callback(stateValueCopy);
      pipedriveExportState.setShowPopup(false);
    } else {
      setErrors({
        apikey: !stateValues.apikey,
        companyDomain: !stateValues.companyDomain,
      });
    }
  };

  const setInputValues = (name, value) => {
    setErrors({
      ...errors,
      [name]: errors[name] !== '' ? !value : errors[name],
    });
    setStateValues({ ...stateValues, [name]: value });
  };

  React.useEffect(() => {
    if (!pipedriveExportState.showPopup) {
      setErrors(defautState);
      setStateValues(defautState);
    }
  }, [pipedriveExportState.showPopup]);

  return pipedriveExportState.showPopup ? (
    <>
      <div className="pipedriveAuthModal confirmation-popup common-popup">
        <section className="authContianer popup-wrap">
          <div
            className="popup-close"
            title="Click here to close"
            onClick={() => pipedriveExportState.setShowPopup(false)}
          >
            <CloseIcon />
          </div>
          <CRMExportHeader
            Logo={PipedriveExportIcon}
            title="Pipedrive Export"
            message="Use your Pipedrive API Key for connecting with Adapt"
          />
          <div className="popup-body">
            <Input
              inputProps={{
                type: 'text',
                name: 'pipedriveKey',
                id: 'apikey',
                placeholder: 'Enter Pipedrive API Key here.',
                onChange: value => setInputValues('apikey', value),
                value: stateValues.apikey,
                required: true,
              }}
              className="api-key-wrap"
              error={errors.apikey ? 'Please enter the API key' : ''}
              label="API Key"
            />
            <Input
              inputProps={{
                type: 'text',
                name: 'pipedriveInstanceUrl',
                id: 'companyDomain',
                placeholder: 'Example: https://companydomainname.pipedrive.com',
                onChange: value => setInputValues('companyDomain', value),
                value: stateValues.companyDomain,
                required: true,
              }}
              error={
                errors.companyDomain ? 'Please enter the Instance URL' : ''
              }
              label="Company URL"
            />
          </div>
          <div className="footer-section">
            <CancelSaveButton
              saveButtonText="Export"
              handleSave={confirmClick}
              handleCancel={() => pipedriveExportState.setShowPopup(false)}
            />
          </div>
        </section>
      </div>
      <div
        className="common-popup-mask"
        onClick={() => pipedriveExportState.setShowPopup(false)}
      />
    </>
  ) : (
    ''
  );
});

export default PipedriveAuthenticationPopup;
export { PipedriveAuthenticationPopup, pipedriveExportState };
